import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'bookkeeping.upsell.modal.title',
    defaultMessage: 'Add Bookkeeping to your plan'
  },
  titleExistingPlan: {
    id: 'bookkeeping.upsell.modal.title.existing.plan',
    defaultMessage: 'See your real profit \u2014 automatically.'
  },
  description: {
    id: 'bookkeeping.upsell.modal.description',
    defaultMessage:
      "Connect your business accounts and we'll organize your income and expenses for you."
  },
  descriptionSecondary: {
    id: 'bookkeeping.upsell.modal.description.secondary',
    defaultMessage:
      'Most transactions are categorized automatically, and your Profit & Loss, Cash Flow, and Balance Sheet update in real time.'
  },
  priceLabel: {
    id: 'bookkeeping.upsell.modal.price.label',
    defaultMessage: 'New plan total'
  },
  ctaUpgrade: {
    id: 'bookkeeping.upsell.modal.paywall.cta.upgrade',
    defaultMessage: 'Add to plan'
  },
  ctaUpgradeSubtext: {
    id: 'bookkeeping.upsell.modal.paywall.cta.upgrade.subtext',
    defaultMessage: '{tierName} + Bookkeeping (+{price}{unit})'
  },
  ctaDismiss: {
    id: 'bookkeeping.upsell.modal.cta.dismiss',
    defaultMessage: 'Continue without bookkeeping'
  },
  ctaContinueWithPlanOnly: {
    id: 'bookkeeping.upsell.modal.paywall.cta.continue.plan.only',
    defaultMessage: 'Continue with {tierName} only'
  },
  switchToYearly: {
    id: 'bookkeeping.upsell.modal.switch.yearly',
    defaultMessage: 'Switch to a yearly plan'
  },
  terms: {
    id: 'bookkeeping.upsell.modal.paywall.terms',
    defaultMessage:
      'By pressing Add to plan you are agreeing to our Bookkeeping Terms and Conditions.'
  },
  perYear: {
    id: 'per.year',
    defaultMessage: '/yr'
  },
  perMonth: {
    id: 'per.month',
    defaultMessage: '/mo'
  },
  billedFirstYear: {
    id: 'bookkeeping.upsell.modal.billed.first.year',
    defaultMessage: 'For the first year. Then {price}{unit}.'
  },
  billedFirstMonths: {
    id: 'bookkeeping.upsell.modal.billed.first.months',
    defaultMessage:
      'For {duration, plural, one {the first month} other {# months}}. Then {price}{unit}.'
  }
});
